import { useEffect, useRef } from "react";
import { trackEvent } from "@/lib/api";

/**
 * Sprint S — Fire-and-forget event tracker.
 *
 * Sends one event per (event_type, key) pair within the lifetime of the
 * page (or globally for keyless calls). Safe to call on every render.
 *
 * @param {string} eventType  — must be in EVENT_TYPES on the backend.
 * @param {object} meta       — small payload (q, year, child_id, …).
 * @param {string} key        — extra dedupe key (e.g. child_id) so repeated
 *                              opens for DIFFERENT entities still register.
 */
export default function useTrackPage(eventType, meta, key = "") {
  const seenRef = useRef(new Set());

  useEffect(() => {
    if (!eventType) return;
    const k = `${eventType}::${key}`;
    if (seenRef.current.has(k)) return;
    seenRef.current.add(k);
    trackEvent(eventType, meta || {});
  }, [eventType, key]);
}
